import { useReducer } from "react";
import jwtDecode from 'jwt-decode'

const initialState = {
    user: null,
};
const jwtLocalStorage = window.localStorage.getItem('jwt')

if (jwtLocalStorage) {
    const decodedToken = jwtDecode(jwtLocalStorage);

    if (decodedToken.exp * 1000 < Date.now()) {
        window.localStorage.removeItem("jwt");
    } else {
        initialState.user = decodedToken;
    }
}

const useAuthProviderValue = () => {
    const reducer = (state, action) => {
        switch (action.type) {
            case "LOGIN":
                return {
                    ...state,
                    user: action.payload,
                };
            case "LOGOUT":
                return {
                    ...state,
                    user: null,
                };
            default:
                return state;
        }
    };

    const [state, dispatch] = useReducer(reducer, initialState);

    const login = (access_token) => {
		const decoded = jwtDecode(access_token)
        window.localStorage.setItem("jwt", access_token);
        dispatch({ type: "LOGIN", payload: decoded });
    };

    const logout = () => {
        window.localStorage.removeItem("jwt");
        dispatch({ type: "LOGOUT" });
    };

    return {
        user: state.user,
        login,
        logout,
    };
};

export default useAuthProviderValue;
